<template>
  <v-app>
    <v-main>
      <vue-snotify></vue-snotify>
      <router-view/>
    </v-main>
  </v-app>
</template>

<style>
@import '@/assets/css/style.css';
</style>


<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
  created() {
    navigator.serviceWorker.addEventListener(
        'controllerchange', () => {
          if (this.refreshing) return;
          this.refreshing = true;
          window.location.reload();
        }
    );
  },
  methods:{
    changeRTL () {
      this.$vuetify.rtl = true
    },
  }
};
</script>